import { Helmet } from "react-helmet-async"
import { Briefcase, Users, GraduationCap, Heart } from "lucide-react"
import { Link } from "react-router-dom"

export default function Careers() {
  const openings = [
    { title: "Senior Cardiologist", department: "Cardiology", location: "Madinaguda", type: "Full-time" },
    { title: "Staff Nurse", department: "General Ward", location: "All Locations", type: "Full-time" },
    { title: "Lab Technician", department: "Diagnostics", location: "Nallagandla", type: "Full-time" },
    { title: "Physiotherapist", department: "Physiotherapy", location: "Isnapur", type: "Full-time" },
    { title: "Receptionist", department: "Administration", location: "Zaheerabad", type: "Full-time" }
  ]

  return (
    <>
      <Helmet>
        <title>Careers - Pranaam Hospitals</title>
      </Helmet>
      
      <div className="min-h-screen bg-gray-50">
        <div className="relative h-64 md:h-96 bg-gradient-to-r from-brand-teal to-brand-nickel">
          <img src="/images/WomensHealthcareTeam.png" alt="Team" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 flex items-center justify-center">
            <h1 className="text-3xl md:text-5xl font-bold text-white text-center px-4">Join Our Team</h1>
          </div>
        </div>

        <div className="container mx-auto px-4 py-8 md:py-16">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-brand-teal mb-4">Build Your Career with Pranaam</h2>
              <p className="text-base md:text-lg text-gray-700 max-w-3xl mx-auto">
                Join a team of dedicated healthcare professionals committed to making a difference in people's lives.
              </p>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
              <div className="bg-white rounded-lg shadow-lg p-6 text-center">
                <Users className="w-12 h-12 text-brand-teal mx-auto mb-4" />
                <h3 className="font-bold text-lg mb-2">Great Team</h3>
                <p className="text-sm text-gray-600">Work with experienced professionals</p>
              </div>
              <div className="bg-white rounded-lg shadow-lg p-6 text-center">
                <GraduationCap className="w-12 h-12 text-brand-teal mx-auto mb-4" />
                <h3 className="font-bold text-lg mb-2">Learning</h3>
                <p className="text-sm text-gray-600">Continuous training and development</p>
              </div>
              <div className="bg-white rounded-lg shadow-lg p-6 text-center">
                <Heart className="w-12 h-12 text-brand-teal mx-auto mb-4" />
                <h3 className="font-bold text-lg mb-2">Work-Life Balance</h3>
                <p className="text-sm text-gray-600">Supportive work environment</p>
              </div>
              <div className="bg-white rounded-lg shadow-lg p-6 text-center">
                <Briefcase className="w-12 h-12 text-brand-teal mx-auto mb-4" />
                <h3 className="font-bold text-lg mb-2">Growth</h3>
                <p className="text-sm text-gray-600">Career advancement opportunities</p>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6 md:p-10 mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-brand-teal mb-6">Current Openings</h2>
              <div className="space-y-4">
                {openings.map((job, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-4 md:p-6 hover:shadow-md transition-shadow">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                      <div>
                        <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2">{job.title}</h3>
                        <div className="flex flex-wrap gap-3 text-sm text-gray-600">
                          <span>📋 {job.department}</span>
                          <span>📍 {job.location}</span>
                          <span>⏰ {job.type}</span>
                        </div>
                      </div>
                      <Link 
                        to="/contact" 
                        className="bg-brand-teal text-white px-6 py-2 rounded-lg hover:bg-brand-teal/90 transition-colors text-center"
                      >
                        Apply Now
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-brand-teal/10 rounded-lg p-6 md:p-10 text-center">
              <h3 className="text-xl md:text-2xl font-bold text-brand-teal mb-4">Don't see a suitable position?</h3>
              <p className="text-gray-700 mb-6">Send us your resume and we'll keep you in mind for future opportunities.</p>
              <Link 
                to="/contact" 
                className="inline-block bg-brand-teal text-white px-8 py-3 rounded-lg hover:bg-brand-teal/90 transition-colors"
              >
                Submit Your Resume
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
